module.exports = class SmsCampaignsListCtrl
  constructor: ->
    'ngInject'
